export default {
  regionSelector: {
    chooseADisasterRegion: 'Válasszon katasztrófa -régiót',
    lastUpdate: 'Utolsó frissítés'
  }
}
